export default class UniverseList{
    constructor({ universes = [], clickHandler }){
        this.universes = universes;
        this.onClick = clickHandler;
    }

    render(container){

        container.innerHTML = '';

        if (this.universes.length === 0){
            container.innerHTML = `
                <div>
                    <h2>Категории отсутсвуют</h2>
                </div>
            `;
            return;
        }

        container.innerHTML = `
            <div class="page-header-title">
                <h2>Выбрать категорию</h2>
            </div>
        `;

        const universeGrid = document.createElement('div');
        universeGrid.className = 'categories-grid';

        this.universes.forEach(universe =>{
            const universeElement = this.createUniverseElement(universe);
            universeGrid.appendChild(universeElement);
        })

        container.appendChild(universeGrid);
    }

    createUniverseElement1(universe){
        const element = document.createElement('div');
        element.className = 'universe-item';
        element.setAttribute('data-id', universe.id);
        element.innerHTML = `
            <span>${universe.name}</span>
        `;
        this.bindEvent(element, universe)
        return element;
    }

    createUniverseElement(universe){
        const element = document.createElement('div');
        element.className = 'category-card';
        // element.className = 'universe-item';
        element.setAttribute('data-id', universe.id);
        let iconName = '';
        switch(universe.id){
            case 1:
                iconName = 'fas fa-hat-wizard';
                break;
            case 2:
                iconName = 'fa-solid fa-ring';
                break;
            case 3:
                iconName = 'fas fa-shield-alt';
                break;
            case 4:
                iconName = 'fa-solid fa-crown';
                break;
        }
        element.innerHTML = `
            <div class="card-bg bg-${universe.id}"></div>
                <div class="card-content">
                    <div class="card-header">
                        <div class="card-icon icon-${universe.id}">
                            <i class="${iconName}"></i>
                        </div>
                          <!-- <div class="card-badge">20+ персонажей</div> -->
                    </div>
                    <div>
                        <h2 class="card-title title-${universe.id}">${universe.name}</h2>
                        <p class="card-desc">${universe.description}</p>
                    </div>
            </div>
        `;
        this.bindEvent(element, universe)
        return element;
    }

    bindEvent(element, universe){
        element.addEventListener('click', async () =>{
            this.onClick(universe.id);
        })
    }
}